var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgNavOftenbuy = function SvgNavOftenbuy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.954 0a2.31 2.31 0 0 1 2.308 2.308v15.384A2.31 2.31 0 0 1 16.954 20H3.108A2.31 2.31 0 0 1 .8 17.692V2.308A2.31 2.31 0 0 1 3.108 0h13.846Zm-3.116 5.95a1.516 1.516 0 0 0 .497 1.779 4.46 4.46 0 0 1-8.618 0 1.487 1.487 0 1 0-1.545.194 5.975 5.975 0 0 0 11.66 0v-.01a1.516 1.516 0 1 0-1.994-1.964Z",
    fill: "var(--primaryColor)"
  })));
};

export default SvgNavOftenbuy;